export default __webpack_public_path__ + "static/media/CNo.61-4.eb8aa627.jpg";